import { StatisticsListFilter } from '@/models/statistics/statistics-list-filter.model';
import { StatisticsListPayload } from '@/models/statistics/statistics-list-payload.model';
import { StatisticsListItem } from '@/models/statistics/statistics-list.model';
import { api } from '@/services/http.service';
import { showErrorNotification } from '@/utils/show-notification.util';
import { defineStore } from 'pinia';

interface StatisticsListState {
  isStatisticsListLoading: boolean;
  statisticsList: StatisticsListItem[];
}

export const useStatisticsListStore = defineStore('StatisticsListStore', {
  state: (): StatisticsListState => ({
    isStatisticsListLoading: false,
    statisticsList: [],
  }),
  actions: {
    setStatisticsListLoading(isLoading: boolean): void {
      this.isStatisticsListLoading = isLoading;
    },
    getStatisticsList(whitelabelSlug: string, filterList: StatisticsListFilter): Promise<StatisticsListItem[]> {
      const requestPayload: StatisticsListPayload = {
        filterList,
      };

      this.setStatisticsListLoading(true);

      return api.statistics.getStatisticsListRequest.perform(whitelabelSlug, requestPayload)
        .then((data: StatisticsListItem[]): StatisticsListItem[] => {
          this.statisticsList = data;

          return data;
        })
        .catch((error) => {
          showErrorNotification(error);

          return [];
        })
        .finally(() => {
          this.setStatisticsListLoading(false);
        });
    },
  },
});
